var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-table',{attrs:{"title":"Productos Inventariables","headers":_vm.headers,"app":"inventory.movement","api":"inventory","opt":{
    company_id: _vm.company.pk,
    report_type: 'inventory'
  },"dontCreate":"","dontRemove":""},on:{"click:edit":_vm.changeRoute},scopedSlots:_vm._u([{key:"item.updated_date",fn:function({ item }){return [_c('span',{domProps:{"textContent":_vm._s(_vm.dateFormat(item.updated_date))}})]}},{key:"extraToolbar",fn:function(){return [_c('v-divider',{staticClass:"mx-4",attrs:{"inset":"","vertical":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }